import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Grow With">
                            <h2>Exploring New Ways To Help Your Business Grow With Emerging Technologies In
                                Businesses</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>TekRevol helps new businesses grow by exploring new ways through emerging technologies. The
                            significance of building a specific digital system with all aspects covered to help your
                            business foster is high, and the competition is higher. We transform ideas through
                            technology to deliver the best for you.</p>
                        <p>We concentrate on leading trends in the industry and match them with your requirement to
                            produce the perfect solution. We help you advance in today’s ever-competitive market through
                            a strategy that delivers the outcome that you need and ensure long-term sustainability.</p>
                         <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;